<div class="chat-card d-flex flex-column">

  <div class="chat-header d-flex align-items-center p-3">
    <i class="bi bi-chat-dots color-brand-primary me-2"></i>
    <p class="fs-normal fw-800 color-gray-950 mb-0">{{title}}</p>
    <p class="fs-small fw-400 color-gray-400 mb-0 ms-2 text-truncate" *ngIf="subtitle">— {{subtitle}}</p>
  </div>

  <div class="chat-thread flex-grow-1 p-3" #thread (scroll)="onScroll()">
    <div class="text-center mb-3" *ngIf="hasMore">
      <a class="load-more fs-small fw-500 color-gray-500 clickable" (click)="loadMoreRequested.emit()">
        {{loadMoreText}}
      </a>
    </div>

    <ngx-skeleton-loader
      *ngIf="isLoading && !messages.length" count="3" appearance="line"
      [theme]="{height: '44px', 'border-radius': '12px', margin: '0 0 12px 0'}"/>

    <p class="fs-small fw-400 color-gray-400 text-center mb-0" *ngIf="!isLoading && !messages.length">
      {{emptyText}}
    </p>

    <div class="message-row d-flex flex-column mb-3" *ngFor="let message of messages"
         [class.mine]="isMine(message)">
      <div class="bubble fs-small fw-500 px-3 py-2">{{message.body}}</div>
      <span class="meta fs-xsmall fw-400 color-gray-400 mt-1">
        <ng-container *ngIf="!isMine(message) && counterpartName">{{counterpartName}} · </ng-container>
        {{message.createdAt | date: 'HH:mm'}}
      </span>
    </div>
  </div>

  <div class="chat-form p-3">
    <div class="form-errors mb-2" *ngIf="errorKey">
      <p class="mb-0">{{errorKey|translate}}</p>
    </div>

    <div class="d-flex align-items-center">
      <textarea
        class="chat-input flex-grow-1 me-2" rows="1"
        [formControl]="bodyControl" [maxlength]="maxLength" [placeholder]="placeholder"
        (keydown)="onKeydown($event)"></textarea>

      <a class="send-btn clickable" [class.disabled]="isSending || disabled || !bodyControl.value?.trim()"
         (click)="onSubmit()">
        <i class="bi" [class.bi-send-fill]="!isSending" [class.bi-hourglass-split]="isSending"></i>
      </a>
    </div>
  </div>

</div>
